let socket = null;
let pingInterval = null;
import store from './store'

const connectSocket = (authToken) => {
    if (!socket) {
        socket = new WebSocket(process.env.VUE_APP_SOCKET_URL + "?token=" + authToken);

        socket.onopen = () => {
            console.log("WebSocket connesso!");
            pingInterval = setInterval(() => {
                if (socket.readyState === WebSocket.OPEN) {
                    socket.send("ping");
                }
            }, 10000);
        };

        socket.onclose = (event) => {
            console.warn("WebSocket chiuso:", event.code, event.reason);
            clearInterval(pingInterval);
            socket = null;

            console.log(`Riconnessione tra 1 secondo...`);

            setTimeout(() => {
                let token = sessionStorage.getItem('ACCESS_TOKEN');
                store.dispatch("initializeSocket",sessionStorage.getItem('ACCESS_TOKEN'));
                //connectSocket(token);  // Riconnessione con intervallo crescente
            }, 1000);
        };

        socket.onerror = (error) => {
            console.error("Errore WebSocket:", error);
        };

    }
};

const onMessage = (callback) => {
    if (socket) {
        socket.onmessage = null;
        socket.onmessage = callback;
    }
};

const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(message);
    } else {
        console.warn("WebSocket non è aperto.");
    }
};

const closeSocket = () => {
    if (socket) {
        socket.close(1000, 'Chiusura normale');
        clearInterval(pingInterval);
        socket = null;
    }
};

export { connectSocket, sendMessage, onMessage, closeSocket };
